// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"5574d317","455":"be60e834","783":"db964453","956":"eb3ff166"}[chunkId] + ".chunk.js";
};